
import { useCallback, useEffect, useRef, useState } from 'react';

import { selectAllId } from 'pages/tasks/constants';
import { getPriorityName, Priority, Task } from 'types/interfaces';
import { dateToTimestamp, formatTimestamp } from 'utils/date-utils';

import { TaskService } from 'components/services/TaskService';

export const useTasksData = (
  filtersForApi: any,
  isDepartmentsLoaded: boolean,
  selectedDepartmentsFilter: any[],
  selectedDateFilter: { dateFrom: string; dateUntil: string }
) => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState(1);
  
  const getTasks = (data: Task[]) => {
    return [...(data || [])].map((d) => {
      return d;
    });
  };

  const getTasksCallback = useCallback(async () => {
    setLoading(true);
    setTasks([]);
    const isMounted = true;
    
    if (selectedDepartmentsFilter.length < 1) {
      setTasks([]);
    } else {
      const result = await TaskService.getTasks(filtersForApi);
      if (isMounted && result.data) {
        setTotalCount((result.data.total === 0 ? 1 : result.data.total) ?? 1);

        const filteredObjects = getTasks(
          result.data.itemsList.map((x: any) => ({
            ...x,
            priority: getPriorityName(x.priority as unknown as Priority),
            actualStartDate: x.actualStartDate
              ? formatTimestamp(new Date(x.actualStartDate).getTime())
              : '',
            actualEndDate: x.actualEndDate
              ? formatTimestamp(new Date(x.actualEndDate).getTime())
              : '',
            plannedStartDate: x.plannedStartDate
              ? formatTimestamp(new Date(x.plannedStartDate).getTime())
              : '',
            plannedEndDate: x.plannedEndDate
              ? formatTimestamp(new Date(x.plannedEndDate).getTime())
              : '',
            creationDate: x.creationDate
              ? formatTimestamp(new Date(x.creationDate).getTime())
              : ''
          }))
        ).filter((task) => {
          const taskDepartment = task.department;
          if (
            selectedDepartmentsFilter.find(
              (e: { key: string }) => e.key === selectAllId
            )
          ) {
            return true;
          }
          return selectedDepartmentsFilter.length > 0
            ? selectedDepartmentsFilter.some(
              (selectedDepartmentFilter: {
                  key: string | undefined;
                  label: string;
                }) =>
                selectedDepartmentFilter?.key === taskDepartment?.key ||
                  (selectedDepartmentFilter.label === 'Наряды без участков' &&
                    taskDepartment?.key === '')
            )
            : true;
        });
        
        if (
          Number(selectedDateFilter.dateFrom) > 1000 ||
          Number(selectedDateFilter.dateUntil)
        ) {
          const fromDate = Number(selectedDateFilter.dateFrom);
          const untilDate = Number(selectedDateFilter.dateUntil);
          const filteredByDate = filteredObjects.filter((task) => {
            if (!task.creationDate) return false;
            const taskСreationDate = dateToTimestamp(task.creationDate);
            return (
              fromDate <= taskСreationDate &&
              (taskСreationDate <= untilDate || untilDate === 0)
            );
          });
          setTasks(filteredByDate);
        }
        Number(selectedDateFilter.dateFrom) === 0 &&
          Number(selectedDateFilter.dateUntil) === 0 &&
          setTasks(filteredObjects);
        setLoading(false);
      }
    }
    setLoading(false);
  }, [
    filtersForApi,
    selectedDateFilter.dateFrom,
    selectedDateFilter.dateUntil,
    selectedDepartmentsFilter
  ]);

  const previousFiltersRef = useRef<string>('');
  
  useEffect(() => {
    if (!isDepartmentsLoaded) return;

    const newFilters = JSON.stringify(filtersForApi);
    if (newFilters !== previousFiltersRef.current) {
      previousFiltersRef.current = newFilters;
      getTasksCallback();
    }
  }, [isDepartmentsLoaded, filtersForApi, getTasksCallback]);

  return {
    tasks,
    loading,
    setLoading,
    totalCount,
    setTotalCount,
    getTasksCallback,
    setTasks
  };
};